import React from 'react';
import Button from './styles';

Button.defaultProps = {
  children: (
    <button>Confirmar</button>
  ),
};

export default Button;